import React from "react";
import "./css/LoadingOverlay.css";

export default function LoadingOverlay() {
    return (
        <div className="overlay-loading">
            <img src="/loading.gif" alt="Carregando..." className="loading-gif" />
        </div>
    );
}
